import * as React from 'react';
import { SVGProps } from 'react';

const IconFitToDefaultSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M4 1H1v10h3v-1H2V2h2V1zm4 0h3v10H8v-1h2V2H8V1z" />
  </svg>
);
export default IconFitToDefaultSizeXs;
